module.exports = __webpack_public_path__ + "img/supply-flow-sm.eed8e734.svg";